import PrivacyCard from './PrivacyCard';

export default PrivacyCard;
